/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'app/utils/loadable';

export const TemplatePage = lazyLoad(
  () => import('./index'),
  module => module.TemplatePage,
);
